import { useState } from 'react';
import { Delete } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useArchiveInvoicesMutation } from '../../api/gql';
import { ConfirmationDialog } from '../../components/dialogs/ConfirmationDialog';

type Props = {
  invoiceIds: string[];
  onArchived: (failed?: string[]) => void;
  onError?: () => void;
} & ButtonProps;
export const InvoiceArchiveButton = ({ invoiceIds, onArchived, onError, ...rest }: Props) => {
  const { t } = useTranslation();

  const { mutateAsync, isPending } = useArchiveInvoicesMutation();
  const [isOpen, setOpen] = useState(false);
  const close = () => setOpen(false);
  const open = () => setOpen(true);

  const onConfirm = (isConfirmed: boolean) => {
    close();

    if (!isConfirmed) {
      return;
    }

    archive();
  };

  const archive = async () => {
    try {
      const res = await mutateAsync({ invoiceIds: invoiceIds });
      onArchived(res.archive.failed);
    } catch (e) {
      console.error(e);
      onError?.();
    }
  };

  return (
    <>
      <LoadingButton
        loading={isPending}
        variant={'outlined'}
        color={'warning'}
        startIcon={<Delete />}
        onClick={open}
        {...rest}
      >
        {t('archive')}
      </LoadingButton>
      <ConfirmationDialog
        title={t('archiveConfirm.title')}
        description={t('archiveConfirm.description')}
        onClose={onConfirm}
        open={isOpen}
      />
    </>
  );
};
